<!-- 二级节点 -->
<template>
  <div class="twoNode">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 关于二级节点 -->
    <Introduction :title="propsCon.title" :content="propsCon.content" :image="propsCon.img"></Introduction>
    <!-- 应用方案 -->
    <div class="play">
      <h3 class="h3">应用方案</h3>
      <div class="play-content width">
        <div class="play-content-item">
          <div class="playItem">
            <div class="playItemImg">
              <img src="../assets/images/u381.png" alt srcset />
            </div>
            <div class="playItemCon" @mouseover="show=true" @mouseleave="show=false">
              <transition name="el-zoom-in-top">
                <div v-show="show" class="transition-box">
                  <div class="playItemConY">
                    <i class="el-icon-caret-left"></i>
                    <h4>一物一码</h4>
                    <p>通过标识码将每一个工业品都赋予一个唯一的“身份证”标识，包括统一的编码标准、统一的身份识别、统一的信息沟通“语言”，为促进企业间的信息资源集成共享提供坚实基础。</p>
                  </div>
                </div>
              </transition>
              <i class="el-icon-caret-left" v-show="!show"></i>
              <h4>一物一码</h4>
              <p>通过标识码将每一个工业品都赋予一个唯一的“身份证”标识，包括统一的编码标准、统一的身份识别、统一的信息沟通“语言”，为促进企业间的信息资源集成共享提供坚实基础。</p>
            </div>
          </div>
          <div class="playItem">
            <div class="playItemImg">
              <img src="../assets/images/u382.png" alt srcset />
            </div>
            <div class="playItemCon" @mouseover="show1=true" @mouseleave="show1=false">
              <transition name="el-zoom-in-top">
                <div v-show="show1" class="transition-box">
                  <div class="playItemConY">
                    <i class="el-icon-caret-left"></i>
                    <h4>创新营销</h4>
                    <p>通过标识码识别，进行消费者大数据采集，打通多数据无缝连接，洞察消费者需求，勾勒用户画像，实时调整营销策略，降低推广费用，建立互动机制，增加市场影响力，实现创新营销。</p>
                  </div>
                </div>
              </transition>
              <i class="el-icon-caret-left" v-show="!show1"></i>
              <h4>创新营销</h4>
              <p>通过标识码识别，进行消费者大数据采集，打通多数据无缝连接，洞察消费者需求，勾勒用户画像，实时调整营销策略，降低推广费用，建立互动机制，增加市场影响力，实现创新营销。</p>
            </div>
          </div>
        </div>
        <div class="play-content-item">
          <div class="playItem">
            <div class="playItemCon" @mouseover="show2=true" @mouseleave="show2=false">
              <transition name="el-zoom-in-top">
                <div v-show="show2" class="transition-box">
                  <div class="playItemConY">
                    <i class="el-icon-caret-right"></i>
                    <h4>供应链管理</h4>
                    <p>以企业间的信息资源集成共享为基础，使供应链运作从采购开始，以最少的成本，达到最优的运作，最终满足客户的需求。通过原料进厂、产品生产、仓储物流、终端销售、市场消费的全产业链可追溯管理，实现信息资源共享、生产效率提升、服务质量提高、客户需求扩大，使供应链相关企业利益最大化。</p>
                  </div>
                </div>
              </transition>
              <i class="el-icon-caret-right" v-show="!show2"></i>
              <h4>供应链管理</h4>
              <p>以企业间的信息资源集成共享为基础，使供应链运作从采购开始，以最少的成本，达到最优的运作，最终满足客户的需求。通过原料进厂、产品生产、仓储物流、终端销售、市场消费的全产业链可追溯管理，实现信息资源共享、生产效率提升、服务质量提高、客户需求扩大，使供应链相关企业利益最大化。</p>
            </div>
            <div class="playItemImg">
              <img src="../assets/images/u383.png" alt srcset />
            </div>
          </div>
          <div class="playItem">
            <div class="playItemCon" @mouseover="show3=true" @mouseleave="show3=false">
              <transition name="el-zoom-in-bottom">
                <div v-show="show3" class="transition-box">
                  <div class="playItemConY">
                    <i class="el-icon-caret-right"></i>
                    <h4>全生命周期管理</h4>
                    <p>通过将企业的生产管理、备品备件管理和仓储管理与统一的标识系统对接，赋予产品零部件标识码，使全端数据实时打通，实现全生命周期管理。</p>
                  </div>
                </div>
              </transition>
              <i class="el-icon-caret-right" v-show="!show3"></i>
              <h4>全生命周期管理</h4>
              <p>通过将企业的生产管理、备品备件管理和仓储管理与统一的标识系统对接，赋予产品零部件标识码，使全端数据实时打通，实现全生命周期管理。</p>
            </div>
            <div class="playItemImg">
              <img src="../assets/images/u384.png" alt srcset />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <TitleImg :title="sceneCon.title" :image="sceneCon.img" :bgimage="sceneCon.bgimage"></TitleImg>

    <!-- 轮播图 -->
    <div class="carImg">
      <el-carousel trigger="click" class="width" height="400px">
        <el-carousel-item v-for="(item,i) in bannerImg" :key="i">
          <img :src="item.img" alt srcset />
          <h4>{{item.title}}</h4>
          <p>{{item.content}}</p>
          <img :src="item.imgs" class="imm" alt srcset />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Introduction from '../components/Introduction'
import TitleImg from '../components/TitleImg'
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { Introduction, TitleImg, TopImg, Footer },
  props: {},
  data() {
    return {
      propsCon: {
        title: '关于二级节点',
        content: [
          '工业互联网标识解析体系类似于互联网域名系统（DNS），为全球制造业发展和工业互联网普及提供关键资源和基础服务， 以及跨国家、跨地域、跨行业、跨企业的全球信息互联互通能力，是整个工业互联网网络实现互联互通的关键基础设施。主要由三要素组成：一是标识，这就相当于机器、物品的“身份证”；二是标识服务，即利用标识，对机器和物品进行唯一性的定位和信息查询，是实现全球供应链系统和企业生产系统的精准对接、产品的全生命周期管理和智能化服务的前提和基础；三是标识管理，即通过国家工业互联网标识解析体系，实现标识的申请、注册、分配、备案，为机器、物品分配唯一的编码。',
          '2017年11月27日，国务院印发了《关于深化“互联网+先进制造业”发展工业互联网的指导意见》，将“推进标识解析体系建设”列为主要任务之一。',
          '2018年，工业和信息化部发布了《工业互联网发展行动计划（2018-2020年）》，提出“标识解析体系构建行动”。',
          '其中，工业互联网标识解析二级节点是工业互联网标识解析体系的重要组成部分，向上对接标识解析国家顶级节点，向下对接企业标识节点及应用系统， 提供标识注册服务、标识解析服务、标识数据服务、运行监测等功能，是推动标识解析体系建设、应用发展和企业生态构建的重要环节。 目前，工业互联网标识解析二级节点收到业界的高度关注，一批二级节点正在各地快速展开建设和应用探索。',
        ],
        img: require('../assets/images/u371.png'),
      },
      sceneCon: {
        title: '应用场景',
        img: require('../assets/images/u433.png'),
        bgimage: '',
      },
      topImg: {
        title: '工业互联网标识解析体系',
        bgImg: require('../assets/images/u2.png'),
        content: '',
        bl: true,
      },

      show: false,
      show1: false,
      show2: false,
      show3: false,
      bannerImg: [
        {
          img: require('../assets/images/bg1.png'),
          title: '智能化生产',
          imgs: require('../assets/images/u438.png'),
          content:
            '通过标识管理、标识解析、标识发现等标识服务实现企业内部不同信息系统之间、不同企业之间、不同环节之间信息的有效共享，促进全产业链环节互联互通。',
        },
        {
          img: require('../assets/images/bg2.png'),
          title: '个性化定制',
          imgs: require('../assets/images/u442.png'),
          content:
            '利用标识解析、云计算、物联网等技术将全球企业的各类制造资源在平台汇聚，进行统一的管理和调度，以企业需求为核心，通过平台独有的灵活定制功能，为企业提供多元化选择、差异化配置、细致化服务，降低企业成本、提高生产效率，全面支撑企业业务战略落地实施。',
        },
        {
          img: require('../assets/images/bg3.png'),
          title: '网络化协同',
          imgs: require('../assets/images/u447.png'),
          content:
            '标识解析应用服务平台将设计企业、原材料企业、生产企业、物流配送企业的能力进行融合，通过标识码的全球唯一性，给予异构系统国家级的“身份证”，使不同企业间可以通过标识解析进行统一的数据交互，进而实现企业间的设计协同、制造共享、供应链优化。',
        },
        {
          img: require('../assets/images/bg4.png'),
          title: '服务化延伸',
          imgs: require('../assets/images/u450.png'),
          content:
            '通过标识解析技术，对企业的生产、运营和商业发展进行优化升级和协同创新，使企业实现从单纯产品或者服务供应商，向“综合性解决方案”供应商转变，并对设计、研发、生产、营销、售后等环节进行全方位升级，提高产品的附加值，实现企业产业链的延展和提升。',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.play {
  width: 100%;
  padding-bottom: 40px;
  margin-bottom: 10px;
  padding-top: 20px;
  margin-top: 10px;
  background: url('../assets/images/u213.png') 100% 100% no-repeat;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .play-content {
    .play-content-item {
      display: flex;
      .playItem {
        flex: 1;
        display: flex;
        .playItemImg {
          flex: 1;
          height: 245px;
          img {
            width: 100%;
            min-height: 245px;
          }
        }
        .playItemCon {
          position: relative;
          flex: 1;
          height: 245px;
          background-color: #fff;
          .el-icon-caret-left {
            position: absolute;
            top: 50%;
            left: -32px;
            font-size: 50px;
            color: #fff;
            margin-top: -25px;
            border: none;
          }
          .el-icon-caret-right {
            position: absolute;
            top: 50%;
            right: -31px;
            font-size: 50px;
            color: #fff;
            margin-top: -25px;
            border: none;
          }
          h4 {
            text-align: center;
            font-weight: 400;
            font-size: 20px;
          }
          p {
            text-indent: 2em;
            line-height: 18px;
            padding: 0 20px;
          }
        }
        .playItemConY {
          position: absolute;
          top: 0;
          left: 0;
          height: 245px;
          flex: 1;
          background-color: #0078d7;
          .el-icon-caret-left {
            position: absolute;
            top: 50%;
            left: -32px;
            font-size: 50px;
            color: #0078d7;
            margin-top: -25px;
            z-index: 1;
          }
          .el-icon-caret-right {
            position: absolute;
            top: 50%;
            right: -31px;
            font-size: 50px;
            color: #0078d7;
            margin-top: -25px;
            z-index: 1;
          }
          h4 {
            text-align: center;
            font-weight: 400;
            font-size: 20px;
            color: #fff;
          }
          p {
            text-indent: 2em;
            line-height: 18px;
            padding: 0 20px;
            color: #fff;
          }
        }
      }
    }
  }
}

.carImg {
  width: 100%;
  margin-bottom: 5px;
  background: url('../assets/images/u365.png') 100% 100% no-repeat;
  h4 {
    width: 760px;
    position: absolute;
    right: 20px;
    font-size: 18px;
    top: 60px;
    color: #fff;
  }
  p {
    width: 760px;
    color: #fff;
    position: absolute;
    right: 20px;
    line-height: 20px;
    text-indent: 2em;
    top: 120px;
  }
  .imm {
    width: 600px;
    height: 280px;
    color: #fff;
    position: absolute;
    left: 20px;
    top: 60px;
  }
}
</style>
